export default {
    name: 'SpotCardGrid',
    props: {
        spotCardData: {
            type: Object,
            required: true
        }
    },
    setup() {
        const handleButtonClick = function () {
            // Simulate the anchor click
            this.$refs.linkRef.click()
        }

        return {
            handleButtonClick
        }
    }
}
